import React from "react";

import { useNavigate } from "utils";

import { FarmVerification } from "models";

import { Col, Icon, IconButton, Row, TablePanel, Tag } from "components";

export const TableSubPanels = ({ farm }: { farm: FarmVerification }) => {
  const { verified, fieldVerificationsCounts } = farm;

  const navigate = useNavigate();
  const farmState = {
    color: "green",
    text: "approved",
    icon: "tabler/circle-check",
  };
  if (farm.verified === null) {
    farmState.color = "grey-600";
    farmState.text = "not verified";
    farmState.icon = "tabler/help";
  } else if (farm.verified === false) {
    farmState.color = "grey";
    farmState.text = "rejected";
    farmState.icon = "tabler/circle-x";
  }

  const { verifiedFieldCount, rejectedFieldCount, unverifiedFieldCount } = fieldVerificationsCounts;
  const fieldVerificationsCount = verifiedFieldCount + rejectedFieldCount + unverifiedFieldCount;

  const fieldsState = {
    text: "approved",
    icon: "tabler/circle-check",
    color: "green",
  };

  if (unverifiedFieldCount === 0 && rejectedFieldCount > 0 && verifiedFieldCount > 0) {
    fieldsState.text = "partially approved";
    fieldsState.icon = "tabler/circle-check";
  } else if (rejectedFieldCount > 0 && rejectedFieldCount === fieldVerificationsCount) {
    fieldsState.text = "rejected";
    fieldsState.icon = "tabler/circle-x";
    fieldsState.color = "grey";
  } else if (unverifiedFieldCount > 0) {
    fieldsState.text = "not verified";
    fieldsState.icon = "tabler/help";
    fieldsState.color = "grey-600";
  }

  return (
    <div key={farm.id}>
      <Row gutter={[0, 0]} className="farms-sub-panel">
        <Col sm={15} md={15}>
          {/* @ts-expect-error TablePanel not yet in TS */}
          <TablePanel headline="Farm" icon="klim/farm" tag={verified === null && <Tag colour="yellow" text="pending verification" />} />
        </Col>
        <Col sm={2} md={2}>
          {verified === null ? "0" : "1"}/1
        </Col>
        <Col sm={4} md={4} className={`${farmState.color} padding-left-100`}>
          <Icon iconName={farmState.icon} className="icon inline margin-right-25" />
          <span>{farmState.text}</span>
        </Col>
        <Col sm={3} md={3} className="icon-container">
          <IconButton iconName="tabler/eye" type="secondary" onClick={() => navigate(`/verifications/farms/${farm.id}/farm`)} />
        </Col>
      </Row>
      <Row gutter={[0, 0]} className="farms-sub-panel">
        <Col sm={15} md={15}>
          {/* @ts-expect-error TablePanel not yet in TS */}
          <TablePanel headline="Fields" icon="klim/field" tag={unverifiedFieldCount > 0 && <Tag colour="yellow" text="pending verification" />} />
        </Col>
        <Col sm={2} md={2}>
          {rejectedFieldCount + verifiedFieldCount}/{fieldVerificationsCount}
        </Col>
        <Col sm={4} md={4} className={`${fieldsState.color} padding-left-100`}>
          <Icon iconName={fieldsState.icon} className="icon inline margin-right-25" />
          <span>{fieldsState.text}</span>
        </Col>
        <Col sm={3} md={3} className="icon-container">
          <IconButton iconName="tabler/eye" type="secondary" onClick={() => navigate(`/verifications/farms/${farm.id}/fields`)} />
        </Col>
      </Row>
    </div>
  );
};
